import { Component, OnInit, Inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClipboardService } from 'ngx-clipboard';

@Component({
    selector: 'app-install-spec-dialog',
    templateUrl: './install-spec-dialog.component.html',
    styleUrls: ['./install-spec-dialog.component.scss'],
    standalone: false
})
export class InstallSpecDialogComponent implements OnInit {
  tenant: string;
  title: string;
  description: string;
  copy: boolean;
  copyData: any;
  buildInstallSpec: any;
  disabledToggle = false;
  error: any;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private clipboardApi: ClipboardService,
  public matdialogRef: MatDialogRef<InstallSpecDialogComponent>,
  private authService: AuthService) {
    this.title = data.title;
    this.description = data.description;
  }

  ngOnInit(): void {
    this.copy = false;
    this.tenant = this.authService.principal.provider;
    if(this.description.startsWith('{')) {
      this.buildInstallSpec = false;
    } else {
      this.buildInstallSpec = true;
    }
  }

  copyText(data): void {
    this.copyData = data;
    this.copy = true;
    this.clipboardApi.copyFromContent(this.copyData);
    setTimeout(() => {
      this.copy = false;
    }, 5000);
  }

  toggleSelection(): void {
    this.matdialogRef.close(true);
  }

  encryptData(event): void {
    if (!this.buildInstallSpec){
      try {
        this.description = btoa(this.description);
        this.buildInstallSpec = true;
      } catch(e) {
        this.error = e;
        this.disabledToggle = true;
      }
    } else {
      try {
        this.description = atob(this.description);
        this.buildInstallSpec = false;
      } catch(e) {
        this.error = e;
        this.disabledToggle = true;
      }
    }
  }
}

